import { Component } from '@angular/core';

@Component({
    selector: 'tyt-submenu-item',
    template: `
        <mat-menu #submenu>
            <ng-content select="[mat-menu-item]"></ng-content>
        </mat-menu>
        <button mat-menu-item [matMenuTriggerFor]="submenu">
            <ng-content></ng-content>
        </button>
    `,
    styles: [`
        :host { display: contents; }
    `]
})
export class SubMenuItemComponent {
}